import { AxiosPromise } from 'axios'
import { clientBase, http } from '@/api/httpAxios'
import { BuildInfo } from 'interfaces/build-info'

export default class BuildInfoAPI {
  public static getServerBuildInfo(): AxiosPromise<BuildInfo> {
    return http.get(`/general/service/build/server`)
  }

  public static getClientBuildInfo(): AxiosPromise<BuildInfo> {
    return http.get(`/_build.json`, {
      baseURL: clientBase
    })
  }

  public static getClientBuildFromServer(): AxiosPromise<BuildInfo> {
    return http.get('/general/service/build/client')
  }
}
